import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditRepairing = () => {
    const { id } = useParams(); // Get the repair ID from the URL params
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [date, setDate] = useState('');
    const [image, setImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentImage, setCurrentImage] = useState('');
    const navigate = useNavigate();

    // Fetch repair data when the component is mounted
    useEffect(() => {
        fetch(`${BASE_URL}repairs/${id}`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    const repair = data.data;
                    setName(repair.name);
                    setDescription(repair.description);
                    setDate(repair.date.split('T')[0]); // Format date to yyyy-mm-dd
                    setCurrentImage(repair.image);
                } else {
                    alert('Failed to fetch repair data');
                }
            })
            .catch(error => {
                console.error('Error fetching repair data:', error);
                alert('Error fetching repair data');
            });
    }, [id]);

    // Handle form data submission
    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);

        // Create a FormData object to handle file upload
        const formData = new FormData();
        formData.append('name', name);
        formData.append('description', description);
        formData.append('date', date);
        if (image) {
            formData.append('image', image); // Append the new image file if it exists
        }

        // Send a PUT request to update the repair
        fetch(`${BASE_URL}repairs/${id}`, {
            method: 'PUT',
            body: formData,
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.status === 1) {
                    // If repair is updated successfully, navigate back to the repairs list
                    navigate('/RepairingsList');
                } else {
                    alert('Failed to update repair: ' + data.message);
                }
            })
            .catch(error => {
                setLoading(false);
                console.error('Error updating repair:', error);
                alert('Error updating repair.');
            });
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Repair</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* Add breadcrumb items if necessary */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Repair Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Repair Information</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            className="form-control"
                                            placeholder="Enter repair name"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            placeholder="Enter repair description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="image" className="form-label">Image</label>
                                        <input
                                            type="file"
                                            id="image"
                                            className="form-control"
                                            onChange={(e) => setImage(e.target.files[0])}
                                        />
                                        {currentImage && (
                                            <div className="mt-3">
                                                <img
                                                    src={`${BASE_URL}${currentImage}`}
                                                    alt="Current Repair"
                                                    width="150"
                                                    height="150"
                                                />
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-end">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? 'Saving...' : 'Save Changes'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditRepairing;
